'use strict';

import $ from 'jquery';
import '@fancyapps/fancybox';
import enquire from 'enquire.js';

export default class HeroBanner {
  constructor(config) {
    let { breakpoints } = config;
    let $videoContainer = $('.hero-banner__video');

    $videoContainer.fancybox();

    $videoContainer.on('contextmenu', function(){
      return false;
    });

    //play video on desktop only 
    enquire.register(`screen and (min-width:${ breakpoints.desktop }px)`, {
      match: () => {
        let $homeVideo = $('.hero-banner__video');

        if ($homeVideo[0]){
          var sources = document.querySelectorAll('.video-container video source');

          // Define the video object this source is contained inside
          var video = document.querySelector('.video-container video');
          for(var i = 0; i<sources.length;i++) {
            sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
          }
          video.load();
        } 
      },
      unmatch: () => {
      }
    });
  }
}
